export type StoreEnhancerState = object;
